<template>
  <div>
    <Nav></Nav>
    <b-container fluid>
      <b-row align-v="center">
        <b-col>
          <h1>Sucursales</h1>
        </b-col>
        <b-col cols="auto">
          <base-button type="success" size="sm" @click="openCreateModal">
            <b-icon-plus></b-icon-plus> Crear Sucursal
          </base-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6" sm="6" md="6" lg="4" xl="4">
          <b-card no-body class="bg-success">
            <!-- Card body -->
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white">En Linea</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">{{ sucursalesEnLinea }}</span>
                </b-col>
                <b-col md="auto">
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" sm="6" md="6" lg="4" xl="4">
          <b-card no-body class="bg-danger">
            <!-- Card body -->
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white">Desconectadas</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">{{ sucursalesDesconectadas }}</span>
                </b-col>
                <b-col md="auto">
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" sm="6" md="6" lg="4" xl="4">
          <b-card no-body class="bg-info">
            <!-- Card body -->
            <b-card-body>
              <b-row>
                <b-col>
                  <b-card-title title-tag="h5" class="text-uppercase text-muted mb-0 text-white">Total Sucursales</b-card-title>
                  <span class="h2 font-weight-bold mb-0 text-white">{{ sucursalsTable.length }}</span>
                </b-col>
                <b-col md="auto">
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <b-row align-v="center">
        <b-col>
          <b-form-group label="Buscar:">
            <b-form-input type="search" v-model="search" @keyup="page=1" debounce="500" placeholder="Buscar por nombre, código o compañía..."></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="auto">
          <b-form-group label=" " class="mb-3">
            <b-form-checkbox v-model="onlyEnabled" switch>
              Solo habilitadas
              <small v-if="disabledCount" class="text-muted">({{ disabledCount }} deshabilitada{{ disabledCount === 1 ? '' : 's' }} oculta{{ disabledCount === 1 ? '' : 's' }})</small>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xs="12" sm="6" md="6" lg="4" xl="3" v-for="sucursal in filteredSucursales " v-bind:key="sucursal.id">
          <b-card class="">
            <b-row>
              <b-col >
                {{ sucursal.id }} - <b>{{ sucursal.nombre }}</b> ({{ sucursal.code }})<br>
                <b-badge variant="info" class="my-1">{{ sucursal.company_name || 'Sin compañía' }}</b-badge><br>
                {{ sucursal.version }}<br>
                <b-badge pill v-if="sucursal.status" variant="success">En línea</b-badge>
                <b-badge pill v-else variant="secondary">Desconectada</b-badge>
                <b-badge pill v-if="sucursal.enabled" variant="success" class="ml-1">Habilitada</b-badge>
                <b-badge pill v-else variant="warning" class="ml-1">Deshabilitada</b-badge><br>
                <small class="text-muted">
                  <i class="fas fa-clock mr-1"></i>Última conexión:
                  <span :title="formatLastSeenAbs(sucursal.last_seen)">{{ formatLastSeen(sucursal.last_seen) }}</span>
                </small><br>
                <base-button  class="my-1" :disabled="!sucursal.status" @click="sendRemoteAction(sucursal.id,'updatePosVersion')" type="primary" size="sm">Actualizar version POS</base-button>
                <base-button  class="my-1" :disabled="!sucursal.status" @click="sendRemoteAction(sucursal.id,'updateInfo')" type="primary" size="sm">Actualizar Info POS</base-button>
                <base-button v-if="hasPermission('rrn:central:platforms:uber')" class="my-1"  @click="sendUberMenu(sucursal.id)" type="primary" size="sm">Enviar Menu Uber</base-button>
                <base-button class="my-1" @click="toggleEnabled(sucursal)" :type="sucursal.enabled ? 'warning' : 'success'" size="sm">{{ sucursal.enabled ? 'Deshabilitar' : 'Habilitar' }}</base-button>
              </b-col>
              <b-col cols="auto">
                <b-button size="sm" variant="success" @click="$router.push('/sucursal/' + sucursal.id)">Ver Más +</b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col>
          <b-table
            stacked="sm"
            :filter="search"
            striped
            hover
            :fields="tableFields"
            :items="sucursalsTable"
            responsive="md"
            :per-page="byPage"
            :current-page="page"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>

            <template #cell(buttons)="data">
              <b-button-group vertical>
                <b-button size="sm" variant="success" @click="$router.push('/sucursal/' + data.item.id)"
                  >Ver Más +</b-button
                >
                
              </b-button-group>
            </template>
            <template #cell(group)="data">
              {{searchGroup(data.item.group).name}}
            </template>
            <template #cell(subgroup)="data">
              {{searchSubgroup(data.item.subgroup).name}}
            </template>
            <template #cell(status)="data">
                <b-badge pill v-if="data.item.status" variant="success">En línea</b-badge>
                <b-badge pill v-else variant="secondary">Desconectada</b-badge>
                <b-badge pill v-if="data.item.enabled" variant="success" class="ml-1">Habilitada</b-badge>
                <b-badge pill v-else variant="warning" class="ml-1">Deshabilitada</b-badge>
                <br>
                <b-button class="mt-1" size="sm" :variant="data.item.enabled ? 'warning' : 'success'" @click="toggleEnabled(data.item)">{{ data.item.enabled ? 'Deshabilitar' : 'Habilitar' }}</b-button>
            </template>
            <template #cell(image)="data"> 
              <img style="max-width: 8vh;" :src="axios.defaults.baseURL + '/' +data.item.image">
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            v-model="page"
            :total-rows="sucursalsTable.length"
            :per-page="byPage"
            aria-controls="my-table"
    ></b-pagination>
        </b-col>
      </b-row> -->

      <b-modal
        id="create-sucursal-modal"
        ref="createSucursalModal"
        title="Crear Sucursal"
        ok-title="Crear"
        ok-variant="success"
        cancel-title="Cancelar"
        :ok-disabled="creating || !newSucursalForm.nombre"
        @ok.prevent="createSucursal"
        @hide="resetCreateForm"
      >
        <b-form @submit.prevent="createSucursal">
          <b-form-group label="Nombre:" label-for="suc-nombre">
            <b-form-input
              id="suc-nombre"
              v-model="newSucursalForm.nombre"
              required
              placeholder="Ej. Sucursal Centro"
              :disabled="creating"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Código:" label-for="suc-code" description="Código corto opcional para identificar la sucursal.">
            <b-form-input
              id="suc-code"
              v-model="newSucursalForm.code"
              placeholder="Ej. CEN"
              :disabled="creating"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Copiar precios desde (opcional):" label-for="suc-copy">
            <b-form-select
              id="suc-copy"
              v-model="newSucursalForm.copy_id"
              :disabled="creating"
            >
              <template #first>
                <b-form-select-option :value="null">-- No copiar --</b-form-select-option>
              </template>
              <b-form-select-option
                v-for="suc in sucursalsTable"
                :key="suc.id"
                :value="suc.id"
              >
                {{ suc.nombre }} ({{ suc.code }})
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-form>
        <div v-if="creating" class="text-center">
          <b-spinner small></b-spinner>
          <small class="ml-2">Creando sucursal...</small>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
import Nav from "../components/Nav.vue";
import axios from "axios";
import moment from "moment";
export default {
  name: "Sucursales",
  components: { Nav },
  data() {
    return {
      sucursalesDesconectadas:null,
      sucursalesEnLinea:null,
      byPage:20,
      page:1,
      sucursalsTable: [],
      search: "",
      // Por defecto la lista oculta las sucursales con enabled=0; el switch las muestra.
      onlyEnabled: true,
      creating: false,
      newSucursalForm: {
        nombre: "",
        code: "",
        copy_id: null,
      },
      tableFields: [
        { key: "id", label: "ID", sortable: true, sortDirection: "desc", class:"align-middle"},
        { key: "nombre", label: "Nombre", sortable: true , class:"align-middle"},
        { key: "version", label: "Version", sortable: true  },
        { key: "status", label: "Status" , sortable: true },
        { key: "buttons", label: "" },
      ],
    };
  },
  activated(){
    this.getAllSucursals();
    
  },
  created() {
    this.getAllSucursals();

  },
  computed: {
    // Sucursales visibles tras el filtro de habilitadas (base del buscador y del contador).
    enabledFiltered() {
      return this.onlyEnabled ? this.sucursalsTable.filter(s => s.enabled) : this.sucursalsTable;
    },
    disabledCount() {
      return this.onlyEnabled ? this.sucursalsTable.filter(s => !s.enabled).length : 0;
    },
    filteredSucursales() {
      if (!this.search || this.search.trim() === '') {
        return this.enabledFiltered;
      }
      const searchTerm = this.search.toLowerCase();
      return this.enabledFiltered.filter(sucursal => {
        return (
          sucursal.nombre.toLowerCase().includes(searchTerm) ||
          (sucursal.code && sucursal.code.toLowerCase().includes(searchTerm)) ||
          (sucursal.company_name && sucursal.company_name.toLowerCase().includes(searchTerm)) ||
          sucursal.id.toString().includes(searchTerm)
        );
      });
    }
  },
  methods: {
    openCreateModal() {
      this.resetCreateForm();
      this.$refs.createSucursalModal.show();
    },
    resetCreateForm() {
      this.newSucursalForm = {
        nombre: "",
        code: "",
        copy_id: null,
      };
    },
    createSucursal() {
      if (!this.newSucursalForm.nombre) {
        this.makeToast("Error", "El nombre es obligatorio", "danger");
        return;
      }
      let that = this;
      let payload = {
        nombre: this.newSucursalForm.nombre,
        code: this.newSucursalForm.code || null,
      };
      let config = {};
      if (this.newSucursalForm.copy_id) {
        config.params = { copy_id: this.newSucursalForm.copy_id };
      }
      this.creating = true;
      axios
        .post("/sucursal", payload, config)
        .then(function (response) {
          that.makeToast(
            "Exito",
            "Sucursal '" + response.data.nombre + "' creada",
            "success"
          );
          that.$refs.createSucursalModal.hide();
          that.getAllSucursals();
          if (response.data && response.data.id) {
            that.$router.push("/sucursal/" + response.data.id);
          }
        })
        .catch(function (err) {
          let msg = err.request && err.request.response
            ? err.request.response
            : (err.message || "Error desconocido");
          that.makeToast("Error", msg, "danger");
        })
        .finally(function () {
          that.creating = false;
        });
    },
    getAllSucursals() {
      let that = this;
      axios
        .get("/sucursals")
        .then(function (response) {
          that.sucursalsTable = response.data.sort((a, b) => { return a.nombre.localeCompare(b.nombre) })
          that.sucursalesDesconectadas=response.data.filter(x=>!x.status).length
          that.sucursalesEnLinea=response.data.filter(x=>x.status).length
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    sendUberMenu(sucursal_id) {
      let that = this
      axios
        .put("/sucursal/" + sucursal_id + "/uber/uploadmenu", null)
        .then(function () {
          that.makeToast("Exito", "EXITO AL SUBIR EL MENU", "success");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });

    },
    async toggleEnabled(sucursal) {
      let newValue = !sucursal.enabled;
      try {
        await axios.patch("/sucursal/" + sucursal.id + "/enabled", { enabled: newValue });
        sucursal.enabled = newValue;
        this.makeToast(
          "Exito",
          "Sucursal " + (newValue ? "habilitada" : "deshabilitada"),
          "success"
        );
        this.getAllSucursals();
      } catch (err) {
        let msg = err.request && err.request.response
          ? err.request.response
          : (err.message || "Error desconocido");
        this.makeToast("Error", msg, "danger");
      }
    },
    sendRemoteAction(sucursal_id,actiontype) {
      let that = this
      axios
        .get("/sucursal/" + sucursal_id + "/action/" + actiontype)
        .then(function () {
          that.makeToast("Exito", "EXITO AL enviar la accion", "success");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });

    },
    parseLastSeen(value) {
      if (!value) return null;
      // Backend stores last_seen with NOW(3) in UTC and the string carries no zone,
      // so parse it as UTC; display helpers convert to the viewer's local time.
      const m = moment.utc(value, ["YYYY-MM-DD HH:mm:ss.SSS", "YYYY-MM-DD HH:mm:ss", moment.ISO_8601], true);
      return m.isValid() ? m : null;
    },
    formatLastSeen(value) {
      const m = this.parseLastSeen(value);
      return m ? m.locale("es").fromNow() : "Nunca";
    },
    formatLastSeenAbs(value) {
      const m = this.parseLastSeen(value);
      return m ? m.local().format("DD/MM/YYYY HH:mm:ss") : "Sin registro de conexión";
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>

<style scoped>
/* Mobile optimization for statistics cards */
@media (max-width: 767px) {
  .bg-success .card-body,
  .bg-danger .card-body,
  .bg-info .card-body {
    padding: 0.5rem !important;
  }

  .bg-success .card-title,
  .bg-danger .card-title,
  .bg-info .card-title {
    font-size: 0.65rem !important;
    line-height: 1.2;
  }

  .bg-success .h2,
  .bg-danger .h2,
  .bg-info .h2 {
    font-size: 1.3rem !important;
  }

  .col-6 {
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }

  .col-6 .card {
    margin-bottom: 0.5rem !important;
  }
}

/* Tablet optimization */
@media (min-width: 768px) and (max-width: 991px) {
  .bg-success .card-body,
  .bg-danger .card-body,
  .bg-info .card-body {
    padding: 1rem !important;
  }

  .bg-success .card-title,
  .bg-danger .card-title,
  .bg-info .card-title {
    font-size: 0.75rem !important;
  }

  .bg-success .h2,
  .bg-danger .h2,
  .bg-info .h2 {
    font-size: 1.75rem !important;
  }
}
</style>
